import { Inject, Injectable, InjectionToken } from '@angular/core';
import { HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { JwtHelperService } from '@auth0/angular-jwt';

import { AuthProvider, RequestOptions } from './auth.provider';
import { User } from '~auth/model';
import { AUTH_CONFIG, AuthConfig } from '~auth/providers/auth.provider';

export const STORAGE: InjectionToken<Storage> = new InjectionToken<Storage>('AUTH_TOKEN_STORAGE');

@Injectable()
export abstract class TokenProvider implements AuthProvider {
  protected jwtHelper = new JwtHelperService();

  constructor(protected storage: Storage, protected authConfig: AuthConfig) {
  }

  isAuthenticated() {
    try {
      const token = this.getToken();
      return token && !this.jwtHelper.isTokenExpired(token) || false;
    } catch (e) {
      return false;
    }
  }

  abstract signIn(username: string, password: string);

  signOut(): Observable<boolean> {
    this.clearToken();
    return Observable.of(true);
  }

  abstract refresh(local?: boolean): Observable<User>;

  public getToken() {
    return this.storage.getItem(this.authConfig.token);
  }

  protected decodeToken(token: string) {
    return this.jwtHelper.decodeToken(token);
  }

  wrapRequest(options: RequestOptions): RequestOptions {
    if (!options) options = {};
    if (!options.headers) options.headers = new HttpHeaders();

    options.headers.append('Authorization', `Bearer ${this.getToken()}`);

    return options;
  }

  intercept(request: HttpRequest<any>): HttpRequest<any> {
    if (this.isAuthenticated()) {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.getToken()}`
        }
      });
    }
    return request;
  }

  protected clearToken() {
    this.storage.removeItem(this.authConfig.token);
    this.storage.removeItem(this.authConfig.token + 'Profile');

    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/providers/token.provider.ts